import { FC } from 'react';
import { Typography } from 'src/components/common';
import MarkdownRenderer from 'react-markdown-renderer';

import './ideaLabelValue.scss';

export type TIdeaLabelValue = {
  label: string;
  value: string;
};

const processMarkdown = (markdown: string) => {
  // Limit heading levels
  const limitedHeadings = markdown
    .replace(/^(#{2,})(\s)/gm, '###### ')
    .replace(/^(#{1,})(\s)/gm, '###### ')
    .replace(/^(#{3,})(\s)/gm, '###### ');
  
  // Preserve paragraph breaks by replacing double newlines first
  const preservedParagraphs = limitedHeadings.replace(/\n\n/g, '\n\n  \n');
  
  // Add two spaces before single newlines to ensure line breaks
  const formattedMarkdown = preservedParagraphs.replace(/\n(?!\n)/g, '  \n');
  
  return formattedMarkdown;
};

const IdeaLabelValue: FC<TIdeaLabelValue> = ({ label, value }: TIdeaLabelValue) => {
  // Check if this is the "no input" response - if so, show it as simple text
  if (value === "Please provide appropriate input to generate an actionable report.") {
    return (
      <div className="idea-label-value no-input-response">
        <div className="idea-label-value__label">
          <Typography variant="body-1" className="idea-label-value__label-text">
            {label}
          </Typography>
        </div>
        <div className="idea-label-value__value">
          <Typography variant="body-2" className="idea-label-value__value-text">
            {value}
          </Typography>
        </div>
      </div>
    );
  }

  const processedValue = processMarkdown(value);

  const containsSpecialMarkdown = value.includes('###') || value.includes('***');
  const containerClass = containsSpecialMarkdown
    ? 'idea-label-value special-markdown'
    : 'idea-label-value regular-markdown';

  return (
    <div className={containerClass}>
      <div className="idea-label-value__label">
        <Typography variant="body-1" className="idea-label-value__label-text">
          {label}
        </Typography>
      </div>
      <div className="idea-label-value__value markdown-content">
        <MarkdownRenderer markdown={processedValue} />
      </div>
    </div>
  );
};

IdeaLabelValue.defaultProps = {
  label: '',
  value: ''
};

export default IdeaLabelValue;
